import { ApiHttpService } from '../ApiHttpService';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const FORGOT_PASSWORD_PATH = 'usuario/forgotpwd';
const CHANGE_PASSWORD_PATH = 'usuario/cambiarpwd';

class PasswordRecoveryController {
  static forgotPassword(userId, recaptchaToken) {
    const headers = {
      captcha: recaptchaToken,
    };
    const params = { login: userId };
    return ApiHttpService.post(`${FORGOT_PASSWORD_PATH}${ParamsHelper.createQueryParams(params)}`, null, false, { headers });
  }

  static changePassword(password, token) {
    const body = {
      Token: token,
      PWD: password,
    };
    return ApiHttpService.post(CHANGE_PASSWORD_PATH, body);
  }
}

export { PasswordRecoveryController };



// WEBPACK FOOTER //
// ./src/networking/controllers/PasswordRecoveryController.js